// uiReducer.js

const initialState = {
    loading: false,  // Default state is loading = false
};

const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload,  // Update the loading state based on the action payload
            };
        default:
            return state;
    }
};

export default uiReducer;
